import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import moment from 'moment';


const BeneficioCard = ({ beneficio, actionDelete }) => {
    

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.bodyCard}>
                <div className={styles.title}>
                    Nome:
                </div>
                <div className={styles.info}>
                    {beneficio.titulo}
                </div>
                <div className={styles.title}>
                    Tipo:
                </div>
                <div className={styles.info}>
                    {beneficio.tipo === 0 ? "Informativo" : (beneficio.tipo === 1 ? "Evento" : "Brindes e premiações")}
                </div>
                <div className={styles.title}>
                    Período
                </div>
                <div className={styles.info}>
                    { beneficio.periodoAtividade === 0 ? "Indeterminado" : `${new moment(beneficio.periodoInicial).format('DD/MM/YYYY')} à ${new moment(beneficio.periodoFinal).format('DD/MM/YYYY')}` }
                </div>
                <div className={styles.title}>
                    Ordem:
                </div>
                <div className={styles.info}>
                    {beneficio.ordemExibicao}
                </div>
            </div>

            <div className={styles.actionWrapper}>

                { beneficio.status === 0 && (<div className={styles.encerrado}>INATIVO</div>) }
                { beneficio.status === 1 && (<div className={styles.andamento}>ATIVO</div>) }
                
                <button className={styles.editar} onClick={() => {if(window.confirm("Tem certeza de deseja apagar este registro?")) actionDelete(beneficio.idVitrineBV);}}>
                    Inativar
                    <FontAwesomeIcon icon={faTimes} className={styles.icon}/>
                </button>

                <button className={styles.editar} onClick={() => {history.push(`/vitrine/detalhe?IdVitrineBV=${beneficio.idVitrineBV}`)}}>
                    Editar
                    <FontAwesomeIcon icon={faEdit} className={styles.icon}/>
                </button>
            </div>

        </div>
    )
}

export default BeneficioCard;